import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'TicketEvent',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TicketEvent',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TicketEvent',
    column_type: 'datetime',
  },
  title: {
    model_name: 'TicketEvent',
    column_type: 'string',
  },
  address1: {
    model_name: 'TicketEvent',
    column_type: 'string',
  },
  address2: {
    model_name: 'TicketEvent',
    column_type: 'string',
  },
  business_hours: {
    model_name: 'TicketEvent',
    column_type: 'string',
  },
  location: {
    model_name: 'TicketEvent',
    column_type: 'string',
  },
  is_show: {
    model_name: 'TicketEvent',
    column_type: 'boolean',
  },
  end_at: {
    model_name: 'TicketEvent',
    column_type: 'datetime',
  },
  start_at: {
    model_name: 'TicketEvent',
    column_type: 'datetime',
  },
  serial_code: {
    model_name: 'TicketEvent',
    column_type: 'string',
  },
  tag_list: {
    model_name: 'TicketEvent',
    column_type: 'tag',
  },
  cover: {
    model_name: 'TicketEvent',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  cover_with_audio: {
    model_name: 'TicketEvent',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  introduction: {
    model_name: 'TicketEvent',
    column_type: 'text',
  },
  faq: {
    model_name: 'TicketEvent',
    column_type: 'text',
  },
  posters: {
    model_name: 'TicketEvent',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  posters_with_audio: {
    model_name: 'TicketEvent',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
